export default "__VITE_ASSET__9NPwN6Vl__"